import { Response } from "@angular/http";

export class ErrorResponse {
    public code: number;
    public error: Response;
    public message: string;

    constructor(error: Response) {
        this.code = error.status;
        this.error = error;

        let body = error.json();

        for (let key in body) {
            if (key == 'code') continue;
            if (key == 'error') continue;
            this[key] = body[key];
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/api/responses/ErrorResponse.ts